import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import { getCollectionList } from "@/api/personalCenter/myCollection";
import { favorOrRecall as _favorOrRecall } from "@/api/serveCenter/serveCenter";
import { bpmnStartProcess } from "@/api/bpmnApi/bpmn";
import IframeView from "@/components/public/IframeView.vue";
export default {
  name: "Collect",
  components: {
    Sift: Sift,
    IframeView: IframeView
  },
  props: [],
  data: function data() {
    return {
      loading: false,
      siftData: [{
        type: "text",
        key: "name",
        label: "服务名称",
        placeholder: "请输入服务名称",
        default: ""
      }],
      list: [],
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10,
        name: ""
      },
      total: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.getListFn();
  },
  methods: {
    HandleApply: function HandleApply(item) {
      var _this = this;

      var processDefId = item.processDefId;
      bpmnStartProcess({
        processDefId: processDefId
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          // this.$refs.IframeView.showView(data.data);
          window.open(data.data.url);
        } else {
          _this.$message.warning(data.msg || "流程系统业务忙，请刷新或者重新操作");
        }
      }).catch(function (err) {
        _this.$message.error("服务异常");
      });
    },
    goHref: function goHref(id, name) {
      var routeData = this.$router.resolve({
        name: name,
        query: {
          id: id
        }
      });
      window.open(routeData.href);
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      this.loading = true;
      getCollectionList(this.paramSearch).then(function (_ref2) {
        var data = _ref2.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.list = data.data.records || [];
          _this2.total = data.data.total;
        }
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.paramSearch = _objectSpread(_objectSpread(_objectSpread({}, this.paramSearch), this.$refs.needSift.getValue()), {}, {
        current: 1
      });
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    goInfo: function goInfo(id) {
      this.$router.push({
        path: "/ServeCenterDetail",
        query: {
          id: id
        }
      });
    },
    favorOrRecall: function favorOrRecall(item) {
      var _this3 = this;

      var params = {
        isFavor: false,
        serveId: item.serveId
      };
      this.loading = true;

      _favorOrRecall(params).then(function (_ref3) {
        var data = _ref3.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("取消收藏成功!");

          _this3.getListFn();
        } else {
          _this3.$message.warning(data.msg || "操作失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;
      });
    },
    //查看
    goQuery: function goQuery(row) {
      if (row.serveType == "0" && row.queryType == "2") {
        this.dataModal.show = true;
        this.dataModal.data = row;
      }

      if (row.serveType == "0" && row.queryType == "1") {
        this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId);
      }
    }
  },
  watch: {},
  filters: {
    formatApplyType: function formatApplyType(val) {
      var obj = {
        1: "线上",
        2: "线上",
        3: "线上和线下"
      };
      return obj[val + ""];
    }
  }
};